module.exports = __webpack_public_path__ + "static/media/registerAndLoginIcon.59258153.svg";